var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.236 8.01562C14.236 7.76942 14.2181 7.52498 14.1896 7.2823L15.6842 5.78769C15.8929 6.50967 16 7.25862 16 8.01562C16 12.4269 12.4113 16.0156 8 16.0156C3.58874 16.0156 0 12.4269 0 8.01562C0 3.60436 3.58874 0.015625 8 0.015625C9.68437 0.015625 11.3088 0.544322 12.6618 1.51603L11.3907 2.78712C10.3872 2.13545 9.21464 1.77963 8 1.77963C4.56146 1.77963 1.764 4.57708 1.764 8.01562C1.764 11.4542 4.56146 14.2516 8 14.2516C11.4385 14.2516 14.236 11.4542 14.236 8.01562ZM5.1237 6.19805L7.73374 8.86438L13.6787 2.79116L14.9148 4.05392L7.73374 11.3896L3.88761 7.4608L5.1237 6.19805Z",
    fill: "#51B37F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.b7c8e9d378953b5f9405f3a1a7fdec14.svg";
export { ForwardRef as ReactComponent };